import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "315f7Q2xuFEqJn0/CVFAegs", "ScaleAct", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, Enum, Vec2, v2, tween, Tween, v3 } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
export var E_ScaleType;

(function (E_ScaleType) {
  E_ScaleType[E_ScaleType["S_Scale"] = 0] = "S_Scale";
  E_ScaleType[E_ScaleType["S_Scale_Delay"] = 1] = "S_Scale_Delay";
  E_ScaleType[E_ScaleType["S_Scale_Twice"] = 2] = "S_Scale_Twice";
})(E_ScaleType || (E_ScaleType = {}));

var ScaleAct = (_dec = menu("act/ScaleAct"), _dec2 = property({
  type: Enum(E_ScaleType),
  tooltip: "缩放类型"
}), _dec3 = property({
  tooltip: "最大缩放值"
}), _dec4 = property({
  tooltip: "最小缩放值"
}), _dec5 = property({
  tooltip: "缩放速度"
}), _dec6 = property({
  visible: function visible() {
    return this.type == E_ScaleType.S_Scale_Delay || this.type == E_ScaleType.S_Scale_Twice;
  },
  tooltip: "缩放间隔"
}), _dec7 = property({
  tooltip: "是否加载后，直接播放"
}), ccclass(_class = _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ScaleAct, _Component);

  function ScaleAct() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "type", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "scale_max", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "scale_min", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "speed", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "delayTime", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "isPlayedOnLoad", _descriptor6, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_initScale", new Vec2(0, 0));

    _defineProperty(_assertThisInitialized(_this), "_aimScale_min", new Vec2(0, 0));

    _defineProperty(_assertThisInitialized(_this), "_aimScale_max", new Vec2(0, 0));

    return _this;
  }

  var _proto = ScaleAct.prototype;

  _proto.onLoad = function onLoad() {
    this._initScale = v2(this.node.scale.x, this.node.scale.y);
  };

  _proto.start = function start() {
    if (this.isPlayedOnLoad) {
      this.act();
    }
  };

  _proto.act = function act() {
    switch (this.type) {
      case E_ScaleType.S_Scale:
        this.handleS_Scale();
        break;

      case E_ScaleType.S_Scale_Delay:
        this.handleS_Scale_Delay();
        break;

      case E_ScaleType.S_Scale_Twice:
        this.handleS_Scale_Twice();
        break;
    }
  };

  _proto.handleS_Scale = function handleS_Scale() {
    this._aimScale_max = v2(this._initScale.x * this.scale_max, this._initScale.y * this.scale_max);
    this._aimScale_min = v2(this._initScale.x * this.scale_min, this._initScale.y * this.scale_min);
    var t1 = (this._aimScale_max.x - this._initScale.x) / (this._aimScale_max.x - this._aimScale_min.x) * this.speed;
    tween(this.node).repeatForever(tween().to(t1, {
      scaleX: this._aimScale_max.x,
      scaleY: this._aimScale_max.y
    }).to(this.speed, {
      scaleX: this._aimScale_min.x,
      scaleY: this._aimScale_min.y
    }).to(this.speed - t1, {
      scaleX: this._initScale.x,
      scaleY: this._initScale.y
    })).start();
  };

  _proto.handleS_Scale_Delay = function handleS_Scale_Delay() {
    this._aimScale_max = v2(this._initScale.x * this.scale_max, this._initScale.y * this.scale_max);
    this._aimScale_min = v2(this._initScale.x * this.scale_min, this._initScale.y * this.scale_min);
    var t1 = (this._aimScale_max.x - this._initScale.x) / (this._aimScale_max.x - this._aimScale_min.x) * this.speed;
    tween(this.node).repeatForever(tween().to(t1, {
      scaleX: this._aimScale_max.x,
      scaleY: this._aimScale_max.y
    }).to(this.speed, {
      scaleX: this._aimScale_min.x,
      scaleY: this._aimScale_min.y
    }, {
      easing: "sineInOut"
    }).delay(this.delayTime).to(this.speed - t1, {
      scaleX: this._initScale.x,
      scaleY: this._initScale.y
    })).start();
  };

  _proto.handleS_Scale_Twice = function handleS_Scale_Twice() {
    Tween.stopAllByTarget(this.node);
    this._aimScale_max = v2(this._initScale.x * this.scale_max, this._initScale.y * this.scale_max);
    this._aimScale_min = v2(this._initScale.x * this.scale_min, this._initScale.y * this.scale_min);
    var x_aim = this._aimScale_min.x;
    var y_aim = this._aimScale_min.y;
    this.node.scale = v3(x_aim, y_aim);
    tween(this.node).repeatForever(tween().to(this.speed, {
      scale: v3(this._aimScale_max.x, this._aimScale_max.y, 1)
    }, {
      easing: "sineInOut"
    }).to(this.speed, {
      scale: v3(this._aimScale_min.x, this._aimScale_min.y, 1)
    }, {
      easing: "sineInOut"
    }).to(this.speed, {
      scale: v3(this._aimScale_max.x, this._aimScale_max.y, 1)
    }, {
      easing: "sineInOut"
    }).to(this.speed, {
      scale: v3(this._aimScale_min.x, this._aimScale_min.y, 1)
    }, {
      easing: "sineInOut"
    }).delay(this.delayTime)).start();
  };

  return ScaleAct;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return E_ScaleType.S_Scale;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "scale_max", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1.2;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "scale_min", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "speed", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "delayTime", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0.1;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "isPlayedOnLoad", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class);
export { ScaleAct as default };

_cclegacy._RF.pop();